<div class="nav">
  <ng-content></ng-content>
</div>
